import React, { Component } from 'react';

import { BrowserRouter } from 'react-router-dom';

import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { ContainerProvider } from '@philips-emr/tws-core/lib/component';
import { RouteContext } from '@philips-emr/tws-core/lib/component/context';
import { arrayOf, element, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';

const acceptedTypes = [
  ComponentType.BEHAVIOR,
];

@AwesomeComponent({ type: ComponentType.BEHAVIOR })
class RouteGroup extends Component {

  static contextType = RouteContext.Context;

  static propTypes = {
    baseName: string,
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    uuid: string,
  };

  getContext() {
    return this.context || new RouteContext();
  }

  render() {
    const { uuid, children, baseName } = this.props;

    const Container = ContainerProvider.provide(this);

    const context = this.getContext().nestedContext(baseName);
    const baseRoute = context.get();

    return (
      <BrowserRouter basename={baseRoute}>
        <Container acceptedTypes={acceptedTypes} className="u-expand" uuid={uuid}>
          <RouteContext.Context.Provider value={null}>
            {children}
          </RouteContext.Context.Provider>
        </Container>
      </BrowserRouter>
    );
  }
}

export default RouteGroup;
